export const EMPLOYEE_PORTAL = 'EMPLOYEE_PORTAL';

export const FACILITIES = 'FACILITIES';

export const ACTION_CREATE = 'CREATE';

export const ACTION_UPDATE = 'UPDATE';
